import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "router-tab" }

import { computed, inject, PropType } from "vue";
import { RouteLocationRaw, useRouter } from "vue-router";
import { Tab } from "tir-components";
import RouterTabButton from "./router-tab-button.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'router-tab',
  props: {
  route: {
    type: Object as PropType<RouteLocationRaw>,
    required: true,
  },
  label: {
    default: null,
    type: String as PropType<string | null>,
  },
  currentTab: {
    default: null,
    type: String,
  },
},
  setup(__props) {

const props = __props;

const router = useRouter();



const isButton = inject("routerTabsIsButton", false);

const tabComponent = computed(() => (isButton ? RouterTabButton : Tab));

const routeFullPath = computed(() => router.resolve(props.route).fullPath);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(tabComponent.value), {
      val: routeFullPath.value,
      label: __props.label,
      "current-tab": __props.currentTab
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["val", "label", "current-tab"]))
  ]))
}
}

})